module.exports = __webpack_public_path__ + "public/images/communication.fb992aa136e7042ec6b1444ecd668c54.png";